import { CardBody } from "reactstrap";
import { QuickAccessLists } from "../../../../../data/applications/FileManager";
import { ContentListProps } from "../../../../../types/Applications";

// This component displays quick access links, folders, and files in a file manager view.
const ContentList: React.FC<ContentListProps> = ({ myFile, fileList, searchFile }) => {
  return (
    <CardBody className="file-manager">
      {!searchFile && (
        <>
          <h5 className="mb-2 f-w-600">{"Quick Access"}</h5>
          <ul className="quick-file d-flex">
            {QuickAccessLists.map((item) => (
              <li key={item.id}>
                <div className="quick-box">
                  <i className={item.quickClass}></i>
                </div>
                <h6>{item.quickTitle}</h6>
              </li>
            ))}
          </ul>
          <h5 className="mt-4 mb-2 f-w-600">{"Folders"}</h5>
          <ul className="folder">
            {myFile.map((item) => (
              <li className="folder-box" key={item.id}>
                <div className="d-block">
                  <i className={`f-44 fa fa-${item.folderClass} txt-warning`} />
                  <i className="fa fa-ellipsis-v me-0 f-14 ellips" />
                  <div className="mt-3">
                    <h6>{item.title}</h6>
                    <p>
                      {item.folderFiles}
                      <span className="pull-right">
                        <i className="fa fa-clock-o me-1" />{item.folderTime}
                      </span>
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
      <h5 className="mt-4 mb-2 f-w-600">{"Files"}</h5>
      <ul className="files-content">{fileList}</ul>
    </CardBody>
  );
};

export default ContentList;